<template>
	<div class="error">
		<div class="title">{{title}}</div>
		<div class="text">{{text}}&nbsp;&nbsp;(-_-｡)</div>
	</div>
</template>

<script>
export default {
	props: {
		title: {type: String, default: "404"},
		text: {type: String, default: "Page not found"}
	},
	created() {
		history.replaceState(null, null, "/");
	}
};
</script>

<style lang="scss" scoped>
.error {
	text-align: center;
	padding: 7em 0 2em;
	color: #000;

	.title {
		font-size: 5em;
		margin-bottom: 0.75em;
		font-weight: 600;
	}
}
</style>
